import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

import { Auth } from '@/api/models';
import {routeByRole, routeByUser} from './helpers';
import { state, actions } from '@/store';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes(authGuard, guestGuard)
});

export default router;

router.beforeEach(async (to, from, next) => {
    if (state.token && !state.user) {
        
        const user = await Auth.me();
        actions.setUser(user);
    }

    // if(state.user){

    //     if(screen.width == 1920 && to.name != 'videowall'){
    //         next({ name:'videowall' });
    //     }

    // }
   
    next();
});

function beforeEnter (routes, callback) {
    return routes.map(route => {
        return { ...route, beforeEnter: callback };
    });
};

function authGuard (routes) {
    return beforeEnter(routes, (to, from, next) => {
        if (!state.token) {
            return next({ name: 'login' });
        }

        if (state.user.firstlogin && to.name !== 'accept') {
            next({ name : 'accept' });
        } else if (state.user.forcepassword && !state.user.firstlogin && to.name !== 'changepass') {
            next({ name : 'changepass' });
        } else {
            next();
        }
    });
};

function guestGuard (routes) {
    return beforeEnter(routes, (to, from, next) => {
        if (state.token) {
            const route = routeByUser(state.user);
            next(route);
        }

        next();
    });
};


















